import { CurrentSurvey } from './models';

export class StoreCurrentSurvey {
  static readonly type = '[Current Survey] Store Current Survey';
  constructor(public currentSurvey: CurrentSurvey) {}
}
